<template>
	<div @mouseenter="isHovering = true" @mouseleave="isHovering = false" v-on="$listeners" class="feature-type-box display-flex flex-column">
		<div :style="topSectionStyle" class="display-flex flex-column width-100 top-section flex-align-center flex-justify-space-between">
			<div class="fake-shadow width-100" :class="{ hidden: true }" />
			<SIcon :name="mainIcon" width="146" height="100" />
			<div class="fake-shadow width-100" />
		</div>
		<div class="secondary-icon-container flex-centerize">
			<SIcon :name="secondaryIcon" />
		</div>
		<div class="display-flex flex-column bottom-section width-100" :style="bottomSectionStyle">
			<div class="bottom-section-content height-100 width-100 display-flex flex-column flex-align-start">
				<div class="title-text">
					{{ featureType.title }}
				</div>
				<h3 v-html="featureType.mainDescription" class="reg" />
				<div class="mt-7">
					<div v-for="(line, i) in descriptionsList" :key="line + i" class="description-text">• {{ line }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FeatureTypeBox',
	props: { featureType: { type: Object }, itemsBackgroundColor: { type: String }, bottomSectionBackgroundColor: { type: String } },
	computed: {
		mainIcon() {
			return this.featureType.mainIcon;
		},
		secondaryIcon() {
			return this.featureType.secondaryIcon;
		},
		descriptionsList() {
			return this.featureType.descriptionsList;
		},
		topSectionStyle() {
			return { background: this.itemsBackgroundColor, transition: '0.3s' };
		},
		bottomSectionStyle() {
			if (this.isHovering) {
				return { background: this.bottomSectionBackgroundColor, transition: '0.3s' };
			}
			return {};
		},
	},
	data() {
		return {
			isHovering: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.feature-type-box {
	width: 286px;
	height: 360px;
	transition: 0.3s;
	overflow: hidden;
	border-radius: 10px;
	background: var(--white);
	border: 1px solid #d6ddea;
	&:hover {
		transition: 0.3s;
		border-color: #1c84fa;
		box-shadow: var(--card-shadow);
	}
}
.top-section {
	.fake-shadow {
		height: 26px;
		opacity: 0.2;
		transition: 0.3s;
		background: transparent linear-gradient(180deg, #f8fbfd00 0%, #7c7e7f93 100%) 0% 0% no-repeat padding-box;
		&.hidden {
			opacity: 0;
		}
	}
}

.bottom-section-content {
	padding: 44px 10px 14px 10px;
}

.title-text {
	font-size: 18px;
	font-weight: 600;
	color: #262626;
	letter-spacing: 0px;
}
.description-text {
	opacity: 0.5;
	font-size: 12px;
	color: #262626;
	letter-spacing: 0px;
}
.secondary-icon-container {
	z-index: 2;
	min-width: 54px;
	max-width: 54px;
	min-height: 54px;
	max-height: 54px;
	margin-top: -28px;
	margin-left: 10px;
	border-radius: 10px;
	background: var(--white);
	border: 1px solid #dbe1ed;
}
.top-section,
.bottom-section {
	min-height: 50%;
}
.bottom-section {
	transition: 0.3s;
	margin-top: -28px;
	background: var(--white);
}
</style>
